<div *ngIf="!uncompletedProfile" class="pt-3">
  <p>
    <button class="btn btn-link" (click)="seeMoreInfo()" data-test-id="see-more-info">
      <h4 class="mb-0 text-primary">
        {{ 'PROFILE_VIEW_SEE_MORE_PROFILE_INFO_HINT' | translate }}
      </h4>
    </button>
  </p>
</div>
<div class="mb-4">
  <button
    type="button"
    class="btn btn-primary my-1 me-3"
    (click)="deactivateAccount()"
    *ngIf="adminSession && !user.is_admin && user.account_status === ACTIVE_ACCOUNT_STATUS"
    [disabled]="!is2AuthLevelPassed || pendingDeactivation"
    data-test-id="profile-deactivate-btn"
  >
    {{ 'PROFILE_VIEW_DEACTIVATE_ACCOUNT_BTN_HINT' | translate }}
  </button>
  <button
    type="button"
    class="btn btn-primary my-1 me-3"
    (click)="reactivateAccount()"
    *ngIf="adminSession && !user.is_admin && user.account_status === DEACTIVATED_ACCOUNT_STATUS"
    [disabled]="!is2AuthLevelPassed || pendingReactivation"
    data-test-id="profile-reactivate-btn"
  >
    {{ 'PROFILE_VIEW_REACTIVATE_ACCOUNT_BTN_HINT' | translate }}
  </button>
  <button
    class="btn btn-primary my-1 me-3"
    type="button"
    appLongOperation
    data-test-id="btn-send-message"
    [disabled]="adminSession || user.is_admin"
    (click)="onSendMessage()"
  >
    {{ 'PROFILE_VIEW_SEND_MSG_BTN_HINT' | translate }}
  </button>
  <button
    *ngIf="!adminSession && !connectionBtn.hidden"
    appLongOperation
    class="btn btn-outline-primary my-1 me-3"
    type="button"
    data-test-id="btn-manage-connections"
    [disabled]="connectionBtn.disabled"
    (click)="manageConnection()"
  >
    {{ connectionBtn.label | translate }}
  </button>
  <button
    *ngIf="activeUserRoleTab == IndividualRoles.doctor && !doctorLinkBtn.hidden"
    appLongOperation
    class="btn btn-outline-primary my-1 me-3"
    type="button"
    data-test-id="btn-manage-doctor-link"
    [disabled]="doctorLinkBtn.disabled"
    (click)="manageDoctorLink()"
  >
    {{ doctorLinkBtn.label | translate }}
  </button>

  <ng-container *ngIf="activeUserRoleTab == IndividualRoles.patient && !patientLinkBtn.hidden">
    <button
      appLongOperation
      class="btn btn-outline-primary my-1 me-3"
      type="button"
      data-test-id="btn-manage-patient-link"
      [disabled]="patientLinkBtn.disabled"
      (click)="managePatientLink()"
    >
      {{ patientLinkBtn.label | translate }}
    </button>
  </ng-container>
</div>

<div class="tab-holder custom-tabs">
  <ul ngbNav #nav="ngbNav" type="pills" (navChange)="onTabClick($event)" class="nav-tabs">
    <li [ngbNavItem]="TabTypes.communities">
      <a ngbNavLink [attr.data-test-id]="TabTypes.communities">
        {{ 'PROFILE_TAB_COMMUNITIES' | translate }}
      </a>

      <ng-template ngbNavContent>
        <app-spinner>
          <app-items-list
            [type]="CardType.COMMUNITY"
            [items]="communities?.items"
            [searchState]="paginationResolver.state"
            [noItemsTitle]="'PROFILE_NO_COMMUNITIES'"
            (pageChanged)="paginationResolver.onPageChanged($event)"
          >
          </app-items-list>
        </app-spinner>
      </ng-template>
    </li>

    <li [ngbNavItem]="TabTypes.projects">
      <a ngbNavLink [attr.data-test-id]="TabTypes.projects">
        {{ 'PROFILE_TAB_PROJECTS' | translate }}
      </a>

      <ng-template ngbNavContent>
        <app-spinner>
          <app-items-list
            [type]="CardType.PROJECT"
            [items]="projects?.items"
            [searchState]="paginationResolver.state"
            [noItemsTitle]="'PROFILE_NO_PROJECTS'"
            (pageChanged)="paginationResolver.onPageChanged($event)"
          >
          </app-items-list>
        </app-spinner>
      </ng-template>
    </li>

    <ng-container *ngIf="adminSession || user.is_admin">
      <li [ngbNavItem]="TabTypes.connections">
        <a ngbNavLink [attr.data-test-id]="TabTypes.connections">
          {{ 'PROFILE_TAB_CONNECTIONS' | translate }}
        </a>

        <ng-template ngbNavContent>
          <div class="pt-4">
            <app-connections-list
              [connections]="connections$ | async"
              [isLoading]="isConnectionsLoading$ | async"
              [searchState]="paginationResolver.state"
              (pageChanged)="paginationResolver.onPageChanged($event)"
            ></app-connections-list>
          </div>
        </ng-template>
      </li>
    </ng-container>

    <li [ngbNavItem]="TabTypes.posts">
      <a ngbNavLink [attr.data-test-id]="TabTypes.posts">
        {{ 'PROFILE_TAB_POSTS' | translate }}
      </a>

      <ng-template ngbNavContent>
        <app-spinner>
          <app-items-list
            [type]="CardType.POST"
            [items]="posts?.items"
            [searchState]="paginationResolver.state"
            [noItemsTitle]="'PROFILE_NO_POSTS'"
            (pageChanged)="paginationResolver.onPageChanged($event)"
          >
          </app-items-list>
        </app-spinner>
      </ng-template>
    </li>

    <ng-container *ngIf="user.doctor">
      <li [ngbNavItem]="TabTypes.doctor_patients">
        <a ngbNavLink [attr.data-test-id]="TabTypes.doctor_patients">
          {{ 'PROFILE_TAB_PATIENTS' | translate }}
        </a>
        <ng-template ngbNavContent>
          <app-spinner>
            <div class="pt-4 pb-4">
              <h2 class="d-inline-block align-middle m-0" data-test-id="distribution-total">
                {{ 'PROFILE_TAB_PATIENTS_TOTAL' | translate: { patients_counts: distributionTotal } }}
              </h2>
            </div>
            <div class="pt-4">
              <h3 class="d-inline-block align-middle m-0" data-test-id="distribution-geographic">
                {{ 'DISTRIBUTION_GEOGRAPHIC' | translate }}
              </h3>
            </div>
            <app-relation-geography
              [relationType]="distributionText"
              [relationGeography]="relationGeographyFetched$ | async"
              [noRelationEntitiesLabel]="'PROFILE_TAB_PATIENTS_HEADER_NO_PATIENTS_YET'"
              [dataTestIdSuffix]="'patients'"
            >
            </app-relation-geography>
          </app-spinner>
        </ng-template>
      </li>
    </ng-container>
  </ul>

  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
